(function () {
  if (window.location.pathname !== '/' || document.querySelector('.fj-home-polish')) {
    return;
  }

  document.body.classList.add('fj-home-polished');

  var style = document.createElement('style');
  style.textContent = "\
    body.fj-home-polished #shopify-section-header .nav-bar__item { padding-top: 9px !important; padding-bottom: 9px !important; }\
    body.fj-home-polished #shopify-section-header .nav-bar__link { font-size: 13px !important; }\
    body.fj-home-polished #shopify-section-slideshow,\
    body.fj-home-polished #shopify-section-1593663238601,\
    body.fj-home-polished #shopify-section-1593662971763,\
    body.fj-home-polished #shopify-section-1593664625434,\
    body.fj-home-polished #shopify-section-1593664661287,\
    body.fj-home-polished #shopify-section-1606319340e4c94b4d,\
    body.fj-home-polished #shopify-section-1593662932657,\
    body.fj-home-polished #shopify-section-1542984811767 { display: none !important; }\
    .fj-home-polish { background: #f3f5f6; border-bottom: 1px solid #e1e3e4; }\
    .fj-home-polish__inner { max-width: 1200px; margin: 0 auto; padding: 34px 40px 26px; }\
    .fj-home-polish__hero { display: grid; grid-template-columns: minmax(0, 1.1fr) minmax(320px, .9fr); gap: 28px; align-items: center; }\
    .fj-home-polish__eyebrow { margin: 0 0 8px; color: #0e67af; font-size: 13px; font-weight: 700; text-transform: uppercase; }\
    .fj-home-polish h1 { margin: 0; color: #080808; font-size: 38px; line-height: 1.12; letter-spacing: 0; }\
    .fj-home-polish__summary { margin: 14px 0 0; max-width: 680px; color: #3b4044; font-size: 16px; line-height: 1.55; }\
    .fj-home-polish__actions { display: flex; flex-wrap: wrap; gap: 10px; margin-top: 20px; }\
    .fj-home-polish__button { display: inline-flex; align-items: center; justify-content: center; min-height: 42px; padding: 0 18px; border-radius: 4px; font-weight: 700; text-decoration: none; }\
    .fj-home-polish__button--primary { background: #0e67af; color: #fff; }\
    .fj-home-polish__button--secondary { background: #fff; color: #0e67af; border: 1px solid #bdd3e6; }\
    .fj-home-polish__panel { background: #fff; border: 1px solid #e1e3e4; border-radius: 8px; padding: 18px; }\
    .fj-home-polish__panel-title { margin: 0 0 12px; font-size: 14px; font-weight: 800; color: #080808; }\
    .fj-home-polish__quick-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 10px; }\
    .fj-home-polish__quick-link { display: block; min-height: 52px; padding: 12px; border-radius: 6px; background: #f8fafb; border: 1px solid #e5e9ec; color: #080808; font-weight: 700; text-decoration: none; }\
    .fj-home-polish__quick-link small { display: block; margin-top: 3px; color: #596168; font-weight: 400; line-height: 1.3; }\
    .fj-home-polish__trust { display: grid; grid-template-columns: repeat(3, minmax(0, 1fr)); gap: 12px; margin-top: 20px; }\
    .fj-home-polish__trust-item { background: #fff; border: 1px solid #e1e3e4; border-radius: 6px; padding: 12px 14px; }\
    .fj-home-polish__trust-item strong { display: block; color: #080808; font-size: 13px; }\
    .fj-home-polish__trust-item span { display: block; margin-top: 3px; color: #596168; font-size: 13px; line-height: 1.4; }\
    body.fj-home-polished #shopify-section-1593662908549 { margin-top: 0; }\
    body.fj-home-polished #shopify-section-1593662908549 .section { padding-top: 28px; }\
    @media screen and (max-width: 900px) {\
      .fj-home-polish__inner { padding: 24px 20px 22px; }\
      .fj-home-polish__hero { grid-template-columns: 1fr; gap: 18px; }\
      .fj-home-polish h1 { font-size: 30px; }\
      .fj-home-polish__summary { font-size: 15px; }\
      .fj-home-polish__trust { grid-template-columns: 1fr; }\
    }\
    @media screen and (max-width: 640px) {\
      .fj-home-polish__inner { padding: 18px 16px 18px; }\
      .fj-home-polish h1 { font-size: 26px; line-height: 1.18; }\
      .fj-home-polish__summary { font-size: 14px; line-height: 1.45; }\
      .fj-home-polish__actions { gap: 8px; margin-top: 16px; }\
      .fj-home-polish__button { width: 100%; min-height: 40px; }\
      .fj-home-polish__panel { padding: 14px; }\
      .fj-home-polish__quick-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 8px; }\
      .fj-home-polish__quick-link { min-height: 44px; padding: 10px; font-size: 13px; line-height: 1.25; }\
      .fj-home-polish__quick-link small { display: none; }\
      .fj-home-polish__trust { display: none; }\
    }\
  ";
  document.head.appendChild(style);

  var section = document.createElement('section');
  section.className = 'fj-home-polish';
  section.setAttribute('aria-label', 'FJ TECH SHOPPER homepage overview');
  section.innerHTML = '' +
    '<div class="fj-home-polish__inner">' +
      '<div class="fj-home-polish__hero">' +
        '<div>' +
          '<p class="fj-home-polish__eyebrow">FJ TECH SHOPPER</p>' +
          '<h1>Electrical, lighting and renovation supplies for local projects.</h1>' +
          '<p class="fj-home-polish__summary">Shop contractor-ready categories including Siemens panels, commercial LED lighting, cabinet hardware, plumbing parts, flooring supplies and building materials. For bulk orders, send a quote request and we will help match products, quantities and delivery timing.</p>' +
          '<div class="fj-home-polish__actions">' +
            '<a class="fj-home-polish__button fj-home-polish__button--primary" href="/pages/contractor-bulk-order-quote">Request Contractor Quote</a>' +
            '<a class="fj-home-polish__button fj-home-polish__button--secondary" href="/collections/electrical">Shop Electrical</a>' +
            '<a class="fj-home-polish__button fj-home-polish__button--secondary" href="/collections/led">Shop LED Lighting</a>' +
          '</div>' +
        '</div>' +
        '<div class="fj-home-polish__panel">' +
          '<p class="fj-home-polish__panel-title">Popular buying paths</p>' +
          '<div class="fj-home-polish__quick-grid">' +
            '<a class="fj-home-polish__quick-link" href="/collections/breakers-panels">Breakers & Panels<small>Siemens panels and electrical supply</small></a>' +
            '<a class="fj-home-polish__quick-link" href="/collections/fixtures">Commercial LED<small>Fixtures, bulbs and emergency lights</small></a>' +
            '<a class="fj-home-polish__quick-link" href="/collections/handles-and-knobs">Cabinet Hardware<small>Handles, knobs, hinges and slides</small></a>' +
            '<a class="fj-home-polish__quick-link" href="/collections/pluming">Plumbing<small>PEX, ABS, PVC and valves</small></a>' +
            '<a class="fj-home-polish__quick-link" href="/collections/building-materials">Building Materials<small>Drill bits, anchors and MDF trim</small></a>' +
            '<a class="fj-home-polish__quick-link" href="/collections/fire-doors-frames">Fire Doors & Frames<small>Door sets and commercial frames</small></a>' +
          '</div>' +
        '</div>' +
      '</div>' +
      '<div class="fj-home-polish__trust">' +
        '<div class="fj-home-polish__trust-item"><strong>Local service area</strong><span>Montreal, Laval, South Shore and nearby job sites.</span></div>' +
        '<div class="fj-home-polish__trust-item"><strong>Bulk order support</strong><span>Send product list, size, quantity and required date.</span></div>' +
        '<div class="fj-home-polish__trust-item"><strong>Project categories</strong><span>Electrical, lighting, hardware, plumbing and renovation supplies.</span></div>' +
      '</div>' +
    '</div>';

  var main = document.getElementById('main');
  if (main) {
    main.insertBefore(section, main.firstChild);
  }
}());
